export enum EnumFolderPaths {
    Location_Categories_Icons = "locationCategories-resources"
}